const getters = {
	getCustomerGlobal: (state) => state.customerGlobal,
	getDetailCustomerGlobal: (state) => state.detailCustomerGlobal,
	getTopFive: (state) => state.topFive,

	// filter
	getPagination: (state) => state.pagination,
	getSearch: (state) => state.search,
	getIsSearchCustomerGlobal: (state) => state.isSerachCustomerGlobal,

	getScrollPosition: (state) => state.scrollPosition,
}

export default getters